import { createApp } from 'vue'
import FLinkCard from '~/js/components/linkCard'
import { LinkItem } from '~/js/models/linkItem'
import { isDesktop } from '~/js/templates/index/helpers'

const CLASS_NAME = 'js-indexFeature'

document.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(CLASS_NAME)
  if (!elements.length) return

  Array.from(elements).forEach((element) => {
    const dataLinkItemElements =
      element.getElementsByClassName('js-dataLinkItem')
    const linkItems = Array.from(dataLinkItemElements).map(
      (dataLinkItemElement) => {
        const linkItem = JSON.parse(dataLinkItemElement.dataset.linkItem)
        const url = JSON.parse(dataLinkItemElement.dataset.url)
        return new LinkItem(linkItem, url)
      }
    )
    const articleCount = isDesktop()
      ? Number(element.dataset.articleCountPc)
      : Number(element.dataset.articleCountSp)

    createApp({
      name: 'TemplatesIndexFeature',
      components: {
        FLinkCard,
      },
      data() {
        return {
          linkItems: linkItems.slice(0, articleCount),
        }
      },
    }).mount(element)
  })
})
